import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/navigation';

export const NAVIGATION_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const NAVIGATION_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;
